export default __webpack_public_path__ + "static/media/product_04.f7c5294d.jpg";